/**
 * Since we have use for this history instance in places other than just App, and
 * exporting from the same module that calls ReactDOM.render will cause Jest tests
 * to fail (see https://stackoverflow.com/a/42611909) we instantiate it here
 * instead :)
 */
import { createBrowserHistory } from 'history'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'

const history = createBrowserHistory()
const packageJson = require('./../package.json')
const version = packageJson.version

Sentry.init({
  integrations: [
    new BrowserTracing({
      // Can also use reactRouterV3Instrumentation or reactRouterV4Instrumentation
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.1,
  release: version,
})

export default history
